import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { WhiteSpace, Button, Icon } from "antd-mobile";
import { FaFacebook } from "react-icons/fa";
import { connect } from "react-redux";
import * as _ from "underscore";
import LoadingIndicator from "../../components/LoadingIndicator";
import * as selectors from "../../selectors";
import * as meAction from "../../actions/me";
import * as authAction from "../../actions/auth";
import { Toast } from "antd-mobile/lib/index";

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledContent = styled(Button)`
  && {
    cursor: pointer;
    width: 100%;
    height: 3em;
    color: #000;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    padding: 10px;
    border-radius: 0px;
  }
`;

const StyledFacebook = styled.span`
  font-size: 1.1em;
  color: #000;
  width: 50%;
  padding-left: 10px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;

const StyledSpan = styled.span`
  font-size: 1.1em;
  color: #000;
  width: 50%;
  padding-right: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const StyledLinked = styled.span`
  font-size: 1em;
  color: green;
  padding-right: 10px;
`;

class LinkedAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      facebook_loading: false
    };
  }

  componentDidMount() {
    this.configureNavBar();
    this.getMeData();
    this.setState({ animationClass: "slide-in-right" });
    this.FB = window.FB;
  }

  getMeData = () => {
    const { getMeData } = this.props;
    getMeData && getMeData();
  };

  onBackPressed = () => {
    const { history } = this.props;

    this.setState({ animationClass: "slide-out-right" });
    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  onFacebookSubmit = () => {
    this.FB = window.FB;
    if (!this.FB) return;

    this.FB.login(this.facebookLoginHandler, {
      scope: "public_profile,email"
    });
    this.setState({ facebook_loading: true });
  };

  facebookLoginHandler = response => {
    const { intl } = this.props;

    if (response.status === "connected") {
      const { accessToken } = response.authResponse;
      const { linkSocialNetwork } = this.props;

      if (linkSocialNetwork && accessToken) {
        linkSocialNetwork && linkSocialNetwork("facebook", accessToken);
      }
    } else {
      Toast.fail(
        intl.formatMessage({
          id: "auth.login.facebook.failed",
          defaultMessage: "Failed to login with Facebook"
        })
      );
    }
    this.setState({ facebook_loading: false });
  };

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <FormattedMessage
        id="profile.social.title"
        defaultMessage="Linked Accounts"
      />
    );

    navbarConfig(navTitle, null, null, () => this.onBackPressed(), null);
    showNavbar(true);
    showTabbar(false);
  };

  getLoadingIndicator = () => {
    const { loading } = this.props;

    return loading ? <LoadingIndicator /> : false;
  };

  render() {
    const { isFacebookConnected } = this.props;
    return (
      <StyledContainer>
        {this.getLoadingIndicator()}
        <StyledContent onClick={() => this.onFacebookSubmit()}>
          <StyledFacebook>
            <FaFacebook
              style={{
                fontSize: "1.5em",
                color:
                  isFacebookConnected && isFacebookConnected
                    ? "#3C5A99"
                    : "gray",
                paddingRight: "10px"
              }}
            />
            <FormattedMessage
              id="profile.social.facebook"
              defaultMessage="Facebook"
            />
          </StyledFacebook>
          <StyledSpan>
            {isFacebookConnected && isFacebookConnected ? (
              <StyledLinked>
                <FormattedMessage
                  id="profile.social.facebook.linked"
                  defaultMessage="Linked"
                />
              </StyledLinked>
            ) : null}
            <Icon type="right" size="md" />
          </StyledSpan>
        </StyledContent>
      </StyledContainer>
    );
  }
}

LinkedAccount.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  authToken: PropTypes.string,
  meData: PropTypes.object,
  loading: PropTypes.bool,
  isFacebookConnected: PropTypes.bool,
  getMeData: PropTypes.func,
  linkSocialNetwork: PropTypes.func
};

function mapStateToProps(state) {
  return {
    authToken: selectors.getAuthToken(state),
    meData: selectors.getMeData(state),
    loading: selectors.getMeLoading(state),
    isFacebookConnected: selectors.getIsFacebookConnected(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getMeData: () => dispatch(meAction.getMeDataRequest()),
    linkSocialNetwork: (channel, token) =>
      dispatch(authAction.linkSocialNetworkRequest(channel, token))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LinkedAccount)
);



// WEBPACK FOOTER //
// ./src/containers/LinkedAccountPage/index.js